import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-2 pb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "お仕事お疲れ様でした！", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "\n        未退勤のお仕事がありますので、退勤または勤怠変更申請を行ってください\n      ", -1)
const _hoisted_4 = { class: "my-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "残業などを実施した場合", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "定刻通りの勤務であった場合", -1)
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "px-2 pb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "\n        給与は勤怠変更申請が承認され次第、申請した内容をもとに給与額がウォレットに反映されます\n      ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "\n        定刻で退勤する場合、「定刻で退勤する」を選択してください\n      ", -1)
const _hoisted_11 = { class: "px-2 pb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "\n        給与は退勤後すぐにウォレットに反映されます\n      ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-danger" }, "退勤後に勤怠を修正することはできません", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "勤怠を修正する場合、「退勤後、勤怠変更申請する」を選択してください", -1)

import { computed, ref } from "vue";
import type { PropType } from "vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import { Application } from "@/types/order/Application";
import WorkInfoTable from "@/views/applications/organisms/WorkInfoTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeavingWorkNeededModal',
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  application: {
    type: Object as PropType<Application>,
    required: true
  }
},
  emits: [
  "finishWork",
  "close"
],
  setup(__props, { emit: emits }) {

const props = __props;



const isShownConfirmFollowScheduledWorkTimeModal = ref(false);
const isShownConfirmRequiredAttendanceCorrectionModal = ref(false);

const attendanceCorrectionRoute = computed(() => ({
  name: "AttendanceCorrection",
  params: {
    applicationId: props.application.id.toString()
  }
}));



function showConfirmFollowScheduledWorkTimeModal() {
  isShownConfirmFollowScheduledWorkTimeModal.value = true;
}
function showConfirmRequiredAttendanceCorrectionModal() {
  isShownConfirmRequiredAttendanceCorrectionModal.value = true;
}
function hideConfirmFollowScheduledWorkTimeModal() {
  isShownConfirmFollowScheduledWorkTimeModal.value = false;
}
function hideConfirmRequiredAttendanceCorrectionModal() {
  isShownConfirmRequiredAttendanceCorrectionModal.value = false;
}
function finishWork(withAttendanceCorrection: boolean) {
  emits("finishWork", withAttendanceCorrection);
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BModal, {
      visible: __props.visible,
      "hide-header": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(),
          _hoisted_3,
          _createTextVNode(),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(WorkInfoTable, { application: __props.application }, null, 8, ["application"])
          ]),
          _createTextVNode(),
          _hoisted_5,
          _createTextVNode(),
          _createVNode(AppButton, {
            block: "",
            onClick: showConfirmRequiredAttendanceCorrectionModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        退勤後、勤怠変更申請する\n      ")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _hoisted_6,
          _createTextVNode(),
          _createVNode(AppButton, {
            block: "",
            onClick: showConfirmFollowScheduledWorkTimeModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        定刻で退勤する\n      ")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode("\n        QRコードが読めない場合は、"),
            _createVNode(_component_RouterLink, {
              class: "text-primary",
              to: attendanceCorrectionRoute.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("勤怠変更申請")
              ], undefined, true),
              _: 1
            }, 8, ["to"]),
            _createTextVNode("してください\n      ")
          ])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["visible"]),
    _createTextVNode(),
    _createVNode(_component_BModal, {
      modelValue: isShownConfirmRequiredAttendanceCorrectionModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShownConfirmRequiredAttendanceCorrectionModal).value = $event)),
      "hide-header": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(),
          _hoisted_10,
          _createTextVNode(),
          _createVNode(AppButton, {
            block: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (finishWork(true))),
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        退勤後、勤怠変更申請する\n      ")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(AppButtonOutline, {
            block: "",
            onClick: hideConfirmRequiredAttendanceCorrectionModal,
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        キャンセル\n      ")
            ], undefined, true),
            _: 1
          })
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modelValue"]),
    _createTextVNode(),
    _createVNode(_component_BModal, {
      modelValue: isShownConfirmFollowScheduledWorkTimeModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isShownConfirmFollowScheduledWorkTimeModal).value = $event)),
      "hide-header": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(),
          _hoisted_13,
          _createTextVNode(),
          _hoisted_14,
          _createTextVNode(),
          _createVNode(AppButton, {
            block: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (finishWork(false))),
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        定刻で退勤する\n      ")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(AppButtonOutline, {
            block: "",
            onClick: hideConfirmFollowScheduledWorkTimeModal,
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("\n        キャンセル\n      ")
            ], undefined, true),
            _: 1
          })
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})